import { SignedVacationDto } from '@app/data/dtos/mot/signed-vacation.dto';
import { IDataResponse } from '@app/entities/interfaces/data/data.interface';
import { SignedVacations } from '@app/entities/models/mot/signed-vacations/signed-vacations.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapSignedVacation: MapFromFn<SignedVacationDto, SignedVacations> = (value) =>
  Builder.forModel(SignedVacations).year(value.year).documentId(value.document_id).build();

export const mapDataSignedVacation: MapFromFn<IDataResponse<SignedVacationDto[]>, SignedVacations[]> = (value) =>
  value.data.map(mapSignedVacation);
